// extracted by mini-css-extract-plugin
export var box = "Box-module--box--07373";
export var paddingBase = "Box-module--paddingBase--d91df";
export var paddingLarge = "Box-module--paddingLarge--c2af4";
export var paddingLargest = "Box-module--paddingLargest--efdb1";
export var paddingMedium = "Box-module--paddingMedium--6fa31";
export var paddingNone = "Box-module--paddingNone--75661";
export var paddingSmall = "Box-module--paddingSmall--3c765";
export var paddingSmallest = "Box-module--paddingSmallest--d57a6";
export var paddingTiny = "Box-module--paddingTiny--19483";
export var paddingXl = "Box-module--paddingXl--ef262";
export var paddingXs = "Box-module--paddingXs--85caf";
export var paddingXxl = "Box-module--paddingXxl--9865e";
export var paddingXxs = "Box-module--paddingXxs--7e2ec";